import React, { useEffect, useState } from 'react'
import '../../../Assets/Css/AddAward.scss'
import { customStyle } from '../../../Components/Style'
import Select from 'react-select'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { FaAward, FaBook, FaCoffee, FaDollarSign, FaGift, FaPlane, FaPuzzlePiece, FaRegClock, FaThumbsUp, FaTrophy } from 'react-icons/fa';
import { addAward, updateAward } from '../../../Services/Award/action';
import { iconMap } from '../../../Lib/utils';

const ChooseIcon = [
    { value: "Trophy", label: "Trophy", icon: iconMap.Trophy },
    { value: "Medal", label: "Medal", icon: iconMap.Medal },
    { value: "TeamWork", label: "TeamWork", icon: iconMap.TeamWork },
    { value: "Award", label: "Award", icon: iconMap.Award },
];

const AddUpdateAwards = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.data?.allData;
    const { employeeId } = useParams();

    const initialState = {
        title: data?.title || null,
        chooseicon: ChooseIcon?.find((item) => item?.value == data?.icon) || null,
        notes: data?.summary || '',
    }

    const [clientData, setClientData] = useState(initialState);

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value
        }))
    }

    const formatOptionLabel = ({ label, icon: Icon }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 15 }}>{Icon && <Icon />}</span>
            <span>{label}</span>
        </div>
    );

    const [colorValue, setColorValue] = useState(data?.icon_background_color || "#ff0000");

    const handleColorChange = (e) => {
        setColorValue(e.target.value);
    };

    const handleTextChange = (e) => {
        setColorValue(e.target.value);
    };

    const handleAddAward = async () => {
        try {
            const body = {
                title: clientData?.title,
                icon: clientData?.chooseicon?.value,
                icon_background_color: colorValue,
                summary: clientData?.notes,
                given_to_employeeId: employeeId,
            }
            if (data) {
                await props?.updateAward(data?.id, body);
            }
            else {
                await props?.addAward({ ...body, status: 'Inactive' });
            }
            navigate(-1);
        } catch (error) {
            console.error("Error adding award: ", error)
        }
    }


    return (
        <div className="addUpdateAward-main">
            <div className="page-title">
                <h4> {location.pathname === "/employees/view/award/add" ? "Add" : "Update"} Award</h4>
                <div className="edit-btn">
                    <button className="custom-btn" onClick={() => navigate(-1)}>
                        {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Cancel"}
                    </button>
                    <button className="custom-btn" onClick={handleAddAward}>
                        {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Save"}
                    </button>
                </div>
            </div>
            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className='add-award-detail'>
                                    {/* <h5 className='award-detail-divider'> Add Award </h5> */}
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Title <span className='required-field'> *</span></h6>
                                                <input type="text" className="input-css" name='title' value={clientData?.title} placeholder="eg : Sales Excellence Awards" onChange={searchFiled} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Choose Icon <span className='required-field'> *</span></h6>
                                                <Select
                                                    options={ChooseIcon}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                    value={clientData.chooseicon}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            chooseicon: val || null
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                    formatOptionLabel={formatOptionLabel}
                                                    filterOption={(option, rawInput) => {
                                                        return option.label.toLowerCase().includes(rawInput.toLowerCase());
                                                    }}
                                                    isClearable
                                                />
                                            </div>
                                        </div>


                                        <div className="col-lg-4">
                                            <div className="input-group" style={{ position: 'relative' }}>
                                                <h6 className="label">Icon Background Color <span className='required-field'> *</span></h6>
                                                <input
                                                    type="text"
                                                    className="input-css"
                                                    name="title"
                                                    placeholder="Color"
                                                    value={colorValue}
                                                    onChange={handleTextChange}
                                                />
                                                <input
                                                    type="color"
                                                    className="color-picker"
                                                    style={{
                                                        position: 'absolute',
                                                        right: '0px',
                                                        top: '73%',
                                                        transform: 'translateY(-50%)',
                                                        height: '43px',
                                                        width: '43px',
                                                        padding: "10px",
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#bfbfbf'
                                                    }}
                                                    onChange={handleColorChange}
                                                    value={colorValue}
                                                />
                                            </div>
                                        </div>


                                        <div className="col-lg-12">
                                            <div className="note-part">
                                                <h6 className="label">Summary</h6>
                                                <div className="editor-custom">
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={clientData?.notes || ""}
                                                        onReady={editor => {
                                                            console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            console.log({ event, editor, data });
                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                notes: data
                                                            }))
                                                        }}
                                                        onBlur={(event, editor) => {
                                                            console.log('Blur.', editor);
                                                        }}
                                                        onFocus={(event, editor) => {
                                                            console.log('Focus.', editor);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        loading: state.awardReducer.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addAward: (data) => {
            dispatch(addAward(data));
        },
        updateAward: (id, data) => {
            dispatch(updateAward(id, data));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateAwards);